export default theme => ({
  SelectCardContainer: {
    padding: '1.25rem',
    border: '1px solid #CED1D6',
    marginBottom: '10px',
    borderRadius: '6px',
  },
  padding: {
    padding: '1rem 0',
  },
  itemCheckbox: {
    '& svg': {
      height: '30px',
      width: '30px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  crossIconBtn: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  innerModal: {
    padding: '0em 1.5em 1.5em',
    maxHeight: '75vh',
    minHeight: '320px',
  },
  customizedModal: {
    maxWidth: '400px',
    minWidth: '400px',
    width: '200px',
  },
  actionBtn: {
    height: '48px !important',
    width: '100%',
  },
  containerPadding: {
    padding: '24px !important',
    [theme.breakpoints.down('sm')]: {
      padding: '0px !important',
    },
  },
  gridContainer: {
    alignItems: 'center',
  },
  btnContainer: {
    marginTop: '26px',
    borderTop: '1px solid #CED1D6',
    display: 'flex',
    justifyContent: 'right',
    '& button': {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  blckBtn: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    color: theme.palette.primary.adgmBlack,
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  btnCls: {
    padding: '15px 40px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  redBtn: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.white,
  },
  modalTitleHead: {
    borderBottom: '1px solid #CED1D6',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid #CED1D6',
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: '0px',
      width: '95%',
      position: 'sticky',
      background: 'white',
    },
  },
  nameCls: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  avatarImg: {
    height: 54,
    width: 54,
    marginRight: 12,
  },
  lightThinValue: {
    fontWeight: '600 !important',
    fontSize: 16,
  },
  lightThinLabel: {
    fontWeight: '400 !important',
    fontSize: 14,
  },
  container: {
    padding: '24px',
    border: '1px solid #D5D6D7',
  },
  detailBody: {
    '&:not(:last-child)': {
      borderBottom: '1px solid #CED1D6',
    },
  },
  noResultsContainer: {
    background: theme.palette.primary.grey,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: '6px',
    padding: '24px',
    margin: '24px 12px',
  },
  title: {
    marginTop: '24px',
    color: theme.palette.secondary.dim,
    fontSize: '21px',
    fontWeight: 600,
    lineHeight: '31.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  subtitle: {
    color: theme.palette.secondary.dim,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  wrapper: { width: '100%' },
  '@media (max-width: 600px)': {
    avatarImg: {
      height: 40,
      width: 40,
      marginRight: 12,
    },
    ownerAvatarimg: {
      marginRight: 12,
    },
    bankPadding: {
      paddingTop: 16,
      paddingBottom: 16,
    },
    lightThinValue: {
      fontWeight: '500 !important',
      fontSize: 12,
    },
    lightThinLabel: {
      fontWeight: '400 !important',
      fontSize: 12,
    },
    paperCardFrame: {
      marginBottom: '0px',
      borderRadius: '0px',
      overflow: 'hidden',
    },
    padding: {
      paddingLeft: 0,
    },
    innercontent: {
      padding: '16px',
    },
    detailsContainer: {
      '&.MuiGrid-spacing-xs-4 > .MuiGrid-item': {
        '&:not(:last-child)': {
          borderBottom: '1px solid #CED1D6',
        },
      },
    },
  },
});
